import { RATE_TYPE } from './config';

export function encodeDataForFormUrlEncodedRequest(obj) {
  if (!obj && typeof obj !== 'object') {
    return obj;
  }

  const data = Object.keys(obj)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&');

  return data;
}

export function getSavedRatingValidation(opinionid, typeid, rateid) {
  let data;
  const rating = ['rateV', opinionid, rateid];
  let jsonData;

  try {
    jsonData = localStorage.getItem(rating.join(':'));
    data = JSON.parse(jsonData) || {};
  } catch (e) {
    data = {};
    console.log('getSavedRatingValidation: json error', e);
  }

  return data;
}

export function saveRatingValidation(
  opinionid,
  typeid,
  rateid,
  count = 1,
  rateType = '',
) {
  const rating = ['rateV', opinionid, rateid];
  const data = {};
  data.count = count;
  const savedRating = getSavedRatingValidation(opinionid, typeid, rateid);

  if (rateType.toUpperCase() === RATE_TYPE.OFFENSIVE) {
    data.offensiveId = typeid;
    data.typeid = savedRating.typeid || '';
  } else {
    data.typeid = typeid;
    data.offensiveId = savedRating.offensiveId || '';
  }
  try {
    localStorage.setItem(rating.join(':'), JSON.stringify(data));
  } catch (e) {
    console.log('local storage not available');
  }
}
